import React, {Fragment} from "react";
import ajax from "./../../lib/ajax.js";
import moment from 'moment';
import context from "./../../lib/context.js";

export default class PendingDocuments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pendingDocumentLogs:[]

        }
        this.getPendingDocumentLogs = this.getPendingDocumentLogs.bind(this);
    }
    componentDidMount() {
        this.getPendingDocumentLogs();
    }

    getPendingDocumentLogs() {
        let url = `get-pending-documents`;
        let self = this;
        ajax.api()
        .get(url)
        .then(result => {
            self.setState({
                pendingDocumentLogs: result.data             
            });           
        }).catch(function (err) {
            let data = err.response? err.response.data : err;
            context.message({
                show: true,
                type: "error",
                message: data.exceptionMessage || data.message,
                buttons: "close" 
            });
        });
    }

    render() {
        const logs = this.state.pendingDocumentLogs;
        let visible = true;
        return (
            <div className={visible ? "ap-pending-documents-panel" : "ap-hidden"}>
                <h4 className="ap-pending-documents-panel-header">My Tasks</h4>
                <div>
                    {
                        logs.map(log => {
                            let moreDocs = log.documents.length > 1 ? (<span className="ap-pending-documents-more-docs">+{log.documents.length - 1} more documents</span>) : "";
                            let imgSrc = log.type == "UPLOAD" ? context.url("images/Upload.svg") : context.url("images/E-Sign.svg");
                            return (
                                <Fragment key={log.logId}>
                                <div className="row ap-ml-0 ap-mr-0 ap-fullsize">
                                    <div className="col-md-8 ap-text-left"> 
                                        <img src={imgSrc} className="ap-pending-document-img" />
                                        <div className="ap-pending-documents-title">
                                            { log.documents[0].title }
                                        </div>
                                        {moreDocs}
                                        <div className="ap-pending-documents-date">Requested on {moment(log.sentDate).format("MMM DD-YYYY")}</div>                                          
                                    </div>
                                    <div className="col-md-4 ap-text-right"> 
                                    <a className="button btn btn-selected ap-pending-documents-btn" target="_blank" href={log.documents[0].processLink}>{log.type == "ESIGN" ? "Review and Sign" : "Upload"}</a>
                                    </div>
                                </div>
                                <hr/>
                                </Fragment>
                            );
                        })                               
                    }
                </div>
            </div>           
        );
    }
}